export type Color =
  | 'primary'
  | 'secondary'
  | 'light'
  | 'dark'
  | 'success'
  | 'warning'
  | 'danger'

export type Tab<T = any> = { [P in keyof T]: T[P] } & {
  id: string
  label: string
}

export enum EQuadboxState {
  unchecked = 'unchecked',
  included = 'included',
  excluded = 'excluded',
  partial = 'partial',
  partialExcluded = 'partial-excluded',
}

export function nextQuadboxState(current: EQuadboxState, strict: boolean): EQuadboxState {
  switch (current) {
    case EQuadboxState.unchecked:
    case EQuadboxState.partial:
    case EQuadboxState.partialExcluded:
      return EQuadboxState.included

    case EQuadboxState.included:
      return strict ? EQuadboxState.unchecked : EQuadboxState.excluded

    case EQuadboxState.excluded:
      return EQuadboxState.unchecked

    default:
      return EQuadboxState.included
  }
}
